import { render, staticRenderFns } from "./EditarVencedoresItemTable.vue?vue&type=template&id=72e8f1e4"
import script from "./EditarVencedoresItemTable.vue?vue&type=script&lang=ts"
export * from "./EditarVencedoresItemTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports